// Externe Bibliotheken
import React from 'react';

// Styles
import './contactModal.scss';

export default function contactModal() {
    return (
        <>
            <p>
                <b>Sie haben es sich anders überlegt?</b>
                <br />
                Kein Problem! Unser Serviceteam hilft Ihnen gern bei der Änderung dieser Leistung.
            </p>
            <div className="contact">
                <div className="phone">
                    <i className="material-symbols-outlined">phone_iphone</i>
                    <a href="tel:+4989998299531">+49 89 9982 99 531</a>
                </div>
                <div className="mail">
                    <i className="material-symbols-outlined">mail</i>
                    <a href="mailto:service@aurumtours.de">service@aurumtours.de</a>
                </div>
            </div>
        </>
    );
}
